import {
  KnownDeliveryDtoDeliveryType,
  KnownProjectModuleSettingsDtoName
} from '@groundfloor-platform/mgmt-service-g-sdk';

// Not all Project Modules have an external Delivery Type mapping
export function mapProjectModuleToExternalDeliveryType(name: string): KnownDeliveryDtoDeliveryType | null {
  switch (name) {
    case KnownProjectModuleSettingsDtoName.InboundParcel:
      return KnownDeliveryDtoDeliveryType.InboundParcel;
    case KnownProjectModuleSettingsDtoName.InboundMail:
      return KnownDeliveryDtoDeliveryType.InboundMail;
    case KnownProjectModuleSettingsDtoName.DryCleaning:
      return KnownDeliveryDtoDeliveryType.InboundDryCleaning;
    case KnownProjectModuleSettingsDtoName.ClickAndCollect:
      return KnownDeliveryDtoDeliveryType.RetailOrder;
    default:
      return null;
  }
}

// Not all Project Modules have an internal Delivery Type mapping
export function mapProjectModuleToInternalDeliveryType(name: string): KnownDeliveryDtoDeliveryType | null {
  switch (name) {
    case KnownProjectModuleSettingsDtoName.DryCleaning:
      return KnownDeliveryDtoDeliveryType.OutboundDryCleaning;
    case KnownProjectModuleSettingsDtoName.OutboundMail:
      return KnownDeliveryDtoDeliveryType.OutboundMail;
    case KnownProjectModuleSettingsDtoName.PeerToPeer:
      return KnownDeliveryDtoDeliveryType.PeerToPeer;
    default:
      return null;
  }
}

export function mapProjectModuleToOutboundLabel(name: string): string | undefined {
  switch (name) {
    case KnownProjectModuleSettingsDtoName.OutboundMail:
      return 'Outbound Mail';
    case KnownProjectModuleSettingsDtoName.DryCleaning:
      return 'Outbound Dry Cleaning';
    default:
      return undefined;
  }
}

export function mapProjectModuleToInboundLabel(name: string): string | undefined {
  switch (name) {
    case KnownProjectModuleSettingsDtoName.InboundMail:
      return 'Inbound Mail';
    case KnownProjectModuleSettingsDtoName.InboundParcel:
      return 'Inbound Parcel';
    case KnownProjectModuleSettingsDtoName.ClickAndCollect:
      return 'Click & Collect';
    case KnownProjectModuleSettingsDtoName.PeerToPeer:
      return 'Peer to Peer';
    case KnownProjectModuleSettingsDtoName.DryCleaning:
      return 'Inbound Dry Cleaning';
    default:
      return undefined;
  }
}

/**
 * This function takes a Delivery Type, but assumes you are interested in the Delivery Transaction Type associated with it.
 * For example, if you provide InboundParcel, it will assume you mean InboundParcelDelivery.
 */
export function mapDeliveryTransactionTypeToProjectModule(type: KnownDeliveryDtoDeliveryType): {
  name: KnownProjectModuleSettingsDtoName;
  type: 'internal' | 'external';
} | null {
  switch (type) {
    case KnownDeliveryDtoDeliveryType.InboundParcel:
      return { name: KnownProjectModuleSettingsDtoName.InboundParcel, type: 'external' };
    case KnownDeliveryDtoDeliveryType.InboundMail:
      return { name: KnownProjectModuleSettingsDtoName.InboundMail, type: 'external' };
    case KnownDeliveryDtoDeliveryType.OutboundMail:
      return { name: KnownProjectModuleSettingsDtoName.OutboundMail, type: 'internal' };
    case KnownDeliveryDtoDeliveryType.PeerToPeer:
      return { name: KnownProjectModuleSettingsDtoName.PeerToPeer, type: 'internal' };
    case KnownDeliveryDtoDeliveryType.RetailOrder:
      return { name: KnownProjectModuleSettingsDtoName.ClickAndCollect, type: 'external' };
    case KnownDeliveryDtoDeliveryType.LockerpointOrder:
      return { name: KnownProjectModuleSettingsDtoName.LockerpointOrders, type: 'external' };
    case KnownDeliveryDtoDeliveryType.InboundDryCleaning:
      return { name: KnownProjectModuleSettingsDtoName.DryCleaning, type: 'external' };
    case KnownDeliveryDtoDeliveryType.OutboundDryCleaning:
      return { name: KnownProjectModuleSettingsDtoName.DryCleaning, type: 'internal' };
    default:
      return null;
  }
}
